import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">焦点专题</h2>
          <p className="text-sm text-foreground-600 mt-3">深度策划专题内容，带你看见瓜田背后的全貌</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="group relative rounded-2xl overflow-hidden border border-background-200/70 bg-background-100 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/7] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold bg-accent-500 text-background-50 mb-3 whitespace-nowrap">
                  {item.label}
                </span>
                <h3 className="text-lg md:text-xl font-heading text-background-50 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-background-200/80 mt-2 line-clamp-2 leading-relaxed">
                  {item.excerpt}
                </p>
                <div className="flex items-center gap-2 mt-3 text-xs text-background-300">
                  <i className="ri-eye-line"></i>
                  <span>{item.stat}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}